var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.999 0H3.111A3.12 3.12 0 000 3.111v18.666a3.12 3.12 0 003.111 3.111h24.888a3.12 3.12 0 003.111-3.111V3.111A3.12 3.12 0 0027.999 0zm0 21.777h-3.111V8.089l-9.333 5.91-9.333-5.91v13.688H3.111V3.111h1.867l10.577 6.533 10.577-6.533H28v18.666z",
    fill: "url(#gmail_svg__paint0_linear_5647_27800)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.999 0H3.111A3.12 3.12 0 000 3.111v18.666a3.12 3.12 0 003.111 3.111h24.888a3.12 3.12 0 003.111-3.111V3.111A3.12 3.12 0 0027.999 0zm0 21.777h-3.111V8.089l-9.333 5.91-9.333-5.91v13.688H3.111V3.111h1.867l10.577 6.533 10.577-6.533H28v18.666z",
    fill: "url(#gmail_svg__paint1_linear_5647_27800)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__paint0_linear_5647_27800",
    x1: 31.731,
    y1: 0.229,
    x2: 7.194,
    y2: 30.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__paint1_linear_5647_27800",
    x1: 4.667,
    y1: 20.999,
    x2: 26.579,
    y2: -2.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F75C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D22B24"
  })))));
}

export default __webpack_public_path__ + "./fonts/gmail.37468e7faa05b1da9e20019c59fd7ebf.svg";
export { SvgGmail as ReactComponent };